import createDataContext from './createDataContext';
import * as actions from './actions/storableAssetsActions';
import { reducer, initialState } from './reducers/storableAssetReducer';

export const { Context: StorableAssetContext, Provider } = createDataContext(
  reducer,
  actions,
  initialState
);
